import React, { useEffect, useMemo, useState } from 'react';
import { useTopicMessage } from '@tier4/autowareviz-react';
import { iv } from '@tier4/autowareviz-messages';
import { PositionalEvent, Time } from '@tier4/autowareviz-core';

export type RemoteClockProps = {
    className?: string;
}

export function RemoteClock(props: RemoteClockProps) {
    const { className } = props;

    const filter = useMemo(() => iv.messageCatalog.coordinate.filter('base_link'), []);
    const tf = useTopicMessage<PositionalEvent & { ts: Time }>('/tf', filter);
    const { ts } = tf ?? {};
    const { sec, nanosec } = ts ?? {};

    const [timeStr, setTimeStr] = useState<string>();
    const [delta, setDelta] = useState<string>();

    useEffect(() => {
        if (sec === undefined || nanosec === undefined) return;

        const msec = sec * 1000 + nanosec / 1000000;

        const absTime = new Date(msec);
        setTimeStr(absTime.toLocaleString());

        const delta = Date.now() - msec;
        const absDelta = Math.abs(delta);

        const tense = (absDelta < 100) ? 'now' : (delta > 0) ? 'before' : 'after';

        let unit: string;
        let value: number | string;
        if (absDelta > 24 /* [h] */ * 60 /* [min] */ * 60000 /* [ms] */) {
            unit = 'days';
            value = Math.floor(absDelta / (24 * 60 * 60000));
        } else if (absDelta > 60 /* [min] */ * 60000 /* [ms] */) {
            unit = 'hours';
            value = Math.floor(absDelta / (60 * 60000));
        } else if (absDelta > 60000 /* [ms] */) {
            unit = 'minutes';
            value = Math.floor(absDelta / (60000));
        } else {
            unit = 'seconds';
            value = (absDelta / 1000.0).toFixed(1);
        }

        setDelta(`${value} ${unit} ${tense}`);
    }, [sec, nanosec]);

    return (
        <div className={className}>
            {
                timeStr
                    ? <><div>{timeStr ?? '????/??/?? 00:00:00'}</div>
                        <div>{delta}</div>
                    </>
                    : <>no valid timestamp found</>
            }
        </div>
    );
}
